export default __webpack_public_path__ + "images/afa0f202d21fd9c29a4221557383f73b-download.svg";